import VuexTypes from '@/store/types/index';

const ProcurementSchemeTypes = VuexTypes.procurementScheme;

export default {
  [ProcurementSchemeTypes.CATEGORIES_LIST]: (state, { data, status }) => {
    state.categoriesList = { data, status };
  },
  [ProcurementSchemeTypes.CATEGORY]: (state, { data, status }) => {
    state.category = { data, status };
  },
  [ProcurementSchemeTypes.CATEGORY_CREATE_DATA]: (state, { data, status }) => {
    state.categoryCreateData = { data, status };
  },
  [ProcurementSchemeTypes.CATEGORY_UPDATE_DATA]: (state, { data, status }) => {
    state.categoryUpdateData = { data, status };
  },
  [ProcurementSchemeTypes.CATEGORY_CREATE]: (state, { data, status }) => {
    state.categoryCreate = { data, status };
  },
  [ProcurementSchemeTypes.CATEGORY_UPDATE]: (state, { data, status }) => {
    state.categoryUpdate = { data, status };
  },
  [ProcurementSchemeTypes.PRODUCTS_LIST]: (state, { data, status }) => {
    state.productsList = { data, status };
  },
  [ProcurementSchemeTypes.PRODUCT]: (state, { data, status }) => {
    state.product = { data, status };
  },
  [ProcurementSchemeTypes.PRODUCT_CREATE_DATA]: (state, { data, status }) => {
    state.productCreateData = { data, status };
  },
  [ProcurementSchemeTypes.PRODUCT_UPDATE_DATA]: (state, { data, status }) => {
    state.productUpdateData = { data, status };
  },
  [ProcurementSchemeTypes.PRODUCT_CREATE]: (state, { data, status }) => {
    state.productCreate = { data, status };
  },
  [ProcurementSchemeTypes.PRODUCT_UPDATE]: (state, { data, status }) => {
    state.productUpdate = { data, status };
  },
  [ProcurementSchemeTypes.PRODUCT_CLASSIFIERS]: (state, { data, status }) => {
    state.productClassifiers = { data, status };
  },
  [ProcurementSchemeTypes.PRODUCT_UPDATE_ACTIVE]: (state, { data, status }) => {
    state.productUpdateActive = { data, status };
  },
};
